export const hardReloadPage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Note(pkocherov@xometry.de): window.reload doesn't work in some specific mobile cases
  window.location.reload();
};
